import { useCallback, useEffect, useState } from 'react';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { IMAGES_REPO } from '../../../../static-resources';
import { AppCopyToClipboardModal } from '../copy-to-clipboard/app-copy-to-clipboard.modal';
import { useShareFilterSelection } from './hooks/use-share-fiter-selection.hook';
import './share-button.component.scss';

interface ShareButtonComponentProps {
  filterSelection: FilterSelectedValue[];
}
export const ShareButtonComponent = ({
  filterSelection,
}: ShareButtonComponentProps) => {
  const [showPopup, setShowPopup] = useState(false);
  const [link, setLink] = useState('');
  const [mailTo, setMailTo] = useState('');
  const location = useLocation();

  const { shareToMSTeamsBody, shareToOutlookBody, shareToOutlookSubject } =
    useShareFilterSelection(filterSelection, link);

  useEffect(() => {
    const origin = window.location.origin;
    const baseUrl = location.pathname;
    const search = location.search;
    setLink(`${origin}${baseUrl}${search}`);
  }, [location]);
  useEffect(() => {
    const str = `mailto:?subject=${encodeURIComponent(shareToOutlookSubject)}&body=${encodeURIComponent(`${shareToOutlookBody}`)}`;
    setMailTo(str);
  }, [link, shareToOutlookBody, shareToOutlookSubject]);
  const onCopyLink = useCallback(() => {
    setShowPopup(true);
  }, []);

  const [showTeamsPopup, setShowTeamsPopup] = useState(false);
  // const onShareToTeams = useCallback(() => {
  //     setShowTeamsPopup(true)
  // }, [])
  // const onShareToOutlook = useCallback(() => {
  //     const link = document.createElement("a");
  //     link.target = "_blank";
  //     link.href = 'to:'
  //     link.click();

  // }, [])
  const onClosePopUp = useCallback((show: boolean) => {
    setShowPopup(show);
  }, []);
  const [_script, setScript] = useState<any>();
  useEffect(() => {
    if (showTeamsPopup && !_script) {
      const script = document.createElement('script');

      script.src = 'https://teams.microsoft.com/share/launcher.js';
      script.async = true;
      script.defer = true;

      document.body.appendChild(script);
      setScript(script);
    }

    return () => {
      if (_script) {
        document.body.removeChild(_script);
        setScript(undefined);
      }
    };
  }, [showTeamsPopup, _script]);

  return (
    <Dropdown
      id="share-button"
      className="share-button"
      title="Share"
      as={ButtonGroup}
      onToggle={() => setShowTeamsPopup(true)}
    >
      <Dropdown.Toggle
        variant="sm"
        className="share-button-component btn-default"
        id="download-button-toggle"
      >
        <img src={IMAGES_REPO.ShareIcon} alt="" />
      </Dropdown.Toggle>
      <Dropdown.Menu align={'end'}>
        <Dropdown.Item as={Button}>
          <div
            className="teams-share-button dropdown-item-img"
            data-href={link}
            data-msg-text={shareToMSTeamsBody}
            data-icon-px-size="16"
          >
            <span> Share via Teams</span>
          </div>
        </Dropdown.Item>
        <Dropdown.Item href={mailTo}>
          <img
            src={IMAGES_REPO.OutlookSmallIcon}
            alt=""
            className="dropdown-item-img"
          />
          Share via Email
        </Dropdown.Item>

        <Dropdown.Item onClick={() => onCopyLink()}>
          <img
            src={IMAGES_REPO.CopyIcon}
            alt=""
            className="dropdown-item-img"
          />
          Share via link
        </Dropdown.Item>
      </Dropdown.Menu>
      <AppCopyToClipboardModal
        link={link}
        onClose={onClosePopUp}
        show={showPopup}
        title="Copy link"
      />
    </Dropdown>
  );
};
